export default __webpack_public_path__ + "static/media/img4-1.6f0c9c0e.jpg";